<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
    />

    <!--    안전검사 대상 기계·기구 종류-->
    <vs-row class="mt-6">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot" /> 안전검사 대상 기계·기구 종류</h5>
      </vs-col>
    </vs-row>

    <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
      <div class="col-span-2 flex items-center"
           v-for="checkbox in form.inspectList"
           v-bind:key="checkbox.id"
      >
        <div v-if="isPrint || board.readonly" class="flex">
          <div v-if="checkbox.check" style="background: #200c63" class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2" >
            <vs-icon icon="check" size="x-small"></vs-icon>
          </div>
          <div v-else style="border: 1px solid #200c63" class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2" >
            <vs-icon icon="check" size="x-small"></vs-icon>
          </div>
          {{ checkbox.label }}
        </div>
        <label v-else class="flex">
          <vs-checkbox
            :readonly="board.readonly"
            v-model="checkbox.check"
            @change="checkForm">
          </vs-checkbox>
          {{ checkbox.label }}
        </label>
      </div>
    </div>

    <!--    표-->
    <div
      v-for="(inspection, indexRows) in form.inspectList"
      v-bind:key="inspection.id"
    >
      <table-inspect
        class="mt-5"
        v-bind:key="inspection.id"
        :is-print="isPrint"
        :is-readonly="board.readonly"
        :is-show-title="true"
        :isNote="true"
        :title="inspection.title"
        :list="inspection.list"
        table-header-title="안전검사 주기"
        table-header-note="비고"
        @update-list-check="(param1, param2)=>{
        updateListCheck(indexRows,param1,param2
        )}"
        v-if="inspection.check"
      />
    </div>

    <!--    사진대지-->
    <PhotoUploadGridModule
      :row-count="2"
      :grid-count="2"
      v-model="form.photoList"
      :isPrint="isPrint"
      :readonly="board.readonly"
      section-title="사진대지"
      placeholder="신축현장 점검"
    />


    <!-- 파일첨부 -->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from '@/views/modules/PhotoUploadGridModule'
import TableInspect from '@/components/TableInspect'
import DateSelector from '@/components/selector/DateSelector'

export default {
  components: {
    PhotoUploadGridModule,
    TableInspect,
    FieldSelectModule,
    FileUploadModule,
    DateSelector,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }

        if (!this.form || !this.form.inspectList || this.form.inspectList.length === 0) {
          this.form.inspectList = this.inspectTable
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},

        typeTitleList: [],
        inspectList: [],
        photoList: [],
        fileList: [],
      },
    };
  },
  methods: {
    checkForm () {
      this.form.typeTitleList = []
      for (const data of this.form.inspectList) {
        if (data.check) {
          this.form.typeTitleList.push(data.label)
        }
      }
    },
    updateListCheck (indexList, indexTableRows, text) {
      this.form.inspectList[indexList].list[indexTableRows].is_checked = text
    },
  },
  computed: {
    inspectTable () {
      return [
        {
          id: 1,
          label: '크레인(이동식 제외)',
          check: false,
          title: '크레인(이동식 제외)',
          list: [
            {
              id: 1,
              label: "사업장에 설치가 끝난 날로부터 3년 이내에 최초 안전검사를 실시하되, 그 이후로부터 2년마다 실시(건설현장에서 사용하는 것은 최초로 설치한 날로부터 6개월마다 실시)",
              is_checked: "",
              note: ''
            },
          ],
        },
        {
          id: 2,
          label: '리프트(이삿짐운반용 제외)',
          check: false,
          title: '리프트(이삿짐운반용 제외)',
          list: [
            {
              id: 1,
              label: "사업장에 설치가 끝난 날로부터 3년 이내에 최초 안전검사를 실시하되, 그 이후로부터 2년마다 실시(건설현장에서 사용하는 것은 최초로 설치한 날로부터 6개월마다 실시)",
              is_checked: "",
              note: ''
            },
          ],
        },
        {
          id: 3,
          label: '곤돌라',
          check: false,
          title: '곤돌라',
          list: [
            {
              id: 1,
              label: "사업장에 설치가 끝난 날로부터 3년 이내에 최초 안전검사를 실시하되, 그 이후로부터 2년마다 실시(건설현장에서 사용하는 것은 최초로 설치한 날로부터 6개월마다 실시)",
              is_checked: "",
              note: ''
            },
          ],
        },
        {
          id: 4,
          label: '이동식 크레인',
          check: false,
          title: '이동식 크레인',
          list: [
            {
              id: 1,
              label: "자동차관리법 제8조에 따른 신규등록 이후 3년 이내에 최초안전검사를 실시하되, 그 이후로부터 2년마다 실시",
              is_checked: "",
              note: ''
            },
          ],
        },
        {
          id: 5,
          label: '이삿짐운반용 리프트',
          check: false,
          title: '이삿짐운반용 리프트',
          list: [
            {
              id: 1,
              label: "자동차관리법 제8조에 따른 신규등록 이후 3년 이내에 최초안전검사를 실시하되, 그 이후로부터 2년마다 실시",
              is_checked: "",
              note: ''
            },
          ],
        },
        {
          id: 6,
          label: '고소작업대',
          check: false,
          title: '고소작업대',
          list: [
            {
              id: 1,
              label: "자동차관리법 제8조에 따른 신규등록 이후 3년 이내에 최초안전검사를 실시하되, 그 이후로부터 2년마다 실시",
              is_checked: "",
              note: ''
            },
          ],
        },
        {
          id: 7,
          label: '압력용기',
          check: false,
          title: '압력용기',
          list: [
            {
              id: 1,
              label: "사업장에 설치가 끝난 날로부터 3년 이내에 최초 안전검사를 실시하되, 그 이후로부터 2년마다 실시(공정안전보고서를 제출하여 확인을 받은 입력용기는 4년마다 실시)",
              is_checked: "",
              note: ''
            },
          ],
        },
        {
          id: 8,
          label: '프레스',
          check: false,
          title: '프레스',
          list: [
            {
              id: 1,
              label: "사업장에 설치가 끝난 날로부터 3년 이내에 최초 안전검사를 실시하되, 그 이후로부터 2년마다 실시(공정안전보고서를 제출하여 확인을 받은 입력용기는 4년마다 실시)",
              is_checked: "",
              note: ''
            },
          ],
        },
        {
          id: 9,
          label: '전단기',
          check: false,
          title: '전단기',
          list: [
            {
              id: 1,
              label: "사업장에 설치가 끝난 날로부터 3년 이내에 최초 안전검사를 실시하되, 그 이후로부터 2년마다 실시(공정안전보고서를 제출하여 확인을 받은 입력용기는 4년마다 실시)",
              is_checked: "",
              note: ''
            },
          ],
        },
        {
          id: 10,
          label: '롤러기',
          check: false,
          title: '롤러기',
          list: [
            {
              id: 1,
              label: "사업장에 설치가 끝난 날로부터 3년 이내에 최초 안전검사를 실시하되, 그 이후로부터 2년마다 실시(공정안전보고서를 제출하여 확인을 받은 입력용기는 4년마다 실시)",
              is_checked: "",
              note: ''
            },
          ],
        },
        {
          id: 11,
          label: '사출성형기',
          check: false,
          title: '사출성형기',
          list: [
            {
              id: 1,
              label: "사업장에 설치가 끝난 날로부터 3년 이내에 최초 안전검사를 실시하되, 그 이후로부터 2년마다 실시(공정안전보고서를 제출하여 확인을 받은 입력용기는 4년마다 실시)",
              is_checked: "",
              note: ''
            },
          ],
        },
        {
          id: 12,
          label: '원심기',
          check: false,
          title: '원심기',
          list: [
            {
              id: 1,
              label: "사업장에 설치가 끝난 날로부터 3년 이내에 최초 안전검사를 실시하되, 그 이후로부터 2년마다 실시(공정안전보고서를 제출하여 확인을 받은 입력용기는 4년마다 실시)",
              is_checked: "",
              note: ''
            },
          ],
        },
        {
          id: 13,
          label: '국소배기장치',
          check: false,
          title: '국소배기장치',
          list: [
            {
              id: 1,
              label: "사업장에 설치가 끝난 날로부터 3년 이내에 최초 안전검사를 실시하되, 그 이후로부터 2년마다 실시(공정안전보고서를 제출하여 확인을 받은 입력용기는 4년마다 실시)",
              is_checked: "",
              note: ''
            },
          ],
        },
        {
          id: 14,
          label: '컨베이어',
          check: false,
          title: '컨베이어',
          list: [
            {
              id: 1,
              label: "사업장에 설치가 끝난 날로부터 3년 이내에 최초 안전검사를 실시하되, 그 이후로부터 2년마다 실시(공정안전보고서를 제출하여 확인을 받은 입력용기는 4년마다 실시)",
              is_checked: "",
              note: ''
            },
          ],
        },
        {
          id: 15,
          label: '산업용 로봇',
          check: false,
          title: '산업용 로봇',
          list: [
            {
              id: 1,
              label: "사업장에 설치가 끝난 날로부터 3년 이내에 최초 안전검사를 실시하되, 그 이후로부터 2년마다 실시(공정안전보고서를 제출하여 확인을 받은 입력용기는 4년마다 실시)",
              is_checked: "",
              note: ''
            },
          ],
        },

      ];
    }
  }
};
</script>

<style scoped lang="scss">
</style>
